import { PrimitiveAtom, Atom, useAtom } from "jotai"

export function useCell<V>(atom: PrimitiveAtom<V>) {
  return useAtom(atom)
}

export function useCellValue<V>(atom: Atom<V>) {
  return useAtom(atom)
}
